import * as React from "react";
import { forwardRef } from "react";
const SmileyHappyIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 1.61538C6.26472 1.61538 1.61537 6.26473 1.61537 12c0 5.7353 4.64935 10.3846 10.38463 10.3846 5.7353 0 10.3846-4.6493 10.3846-10.3846 0-5.73527-4.6493-10.38462-10.3846-10.38462M.230759 12C.230759 5.50003 5.50002.230766 12 .230766 18.5.230766 23.7692 5.50003 23.7692 12c0 6.5-5.2692 11.7692-11.7692 11.7692C5.50002 23.7692.230759 18.5.230759 12",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.56345 14.1279c.26811-.3793.70363-.6048 1.16807-.6048H18.2677c.4645 0 .9001.2255 1.1682.6048.2681.3792.3355.865.1807 1.3029-1.1394 3.2298-4.1919 5.39-7.6169 5.39s-6.47756-2.1602-7.61692-5.39m1.34884-.5231c-.01495 0-.02895.0073-.03758.0195-.00865.0122-.01083.0279-.00583.042.94392 2.6764 3.47348 4.4669 6.31149 4.4669 2.838 0 5.3673-1.79 6.3113-4.4664.005-.0141.003-.0303-.0057-.0425-.0086-.0122-.0226-.0195-.0376-.0195m0 0H5.73162zm-13.70425-.7798c-.26802.379-.33525.8651-.18067 1.3029zM16.4308 7.24615c-.5863 0-1.0616.47526-1.0616 1.06154 0 .58627.4753 1.06153 1.0616 1.06153.5862 0 1.0615-.47526 1.0615-1.06153 0-.58628-.4753-1.06154-1.0615-1.06154m-8.86158 0c-.58627 0-1.06154.47526-1.06154 1.06154 0 .58627.47527 1.06153 1.06154 1.06153s1.06154-.47526 1.06154-1.06153c0-.58628-.47527-1.06154-1.06154-1.06154",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(SmileyHappyIcon);
export { ForwardRef as SmileyHappyIcon };